// extracted by mini-css-extract-plugin
module.exports = {"root":"Errors_root__hZBiS","errors":"Errors_errors__LBNLU"};